import { render } from "./SearcherComponent.vue?vue&type=template&id=edb70002"
import script from "./SearcherComponent.vue?vue&type=script&lang=js"
export * from "./SearcherComponent.vue?vue&type=script&lang=js"

import "@/styles/AdminStyles/SearcherManagersStyles.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__